import * as React from 'react';
import { History } from 'history';
import Model from './address-model';
import BaseList from '../base/base-list.component';

interface IProps {  
  history: History;
  root?: string;
  caption?: string;
  parentType?: string;
  parentId?: number;
  actions?: any;
  disableBackButton?: boolean;
  disableCard?: boolean;
}

interface IState {
}

export default class AddressList extends React.Component<IProps, IState> {
  public render(): React.ReactNode {
    return (
      <BaseList history={this.props.history} caption={this.props.caption} parentId={this.props.parentId} endPointFilter={Model.endPointFilterList(this.props.parentType, this.props.parentId)} url={(this.props.root || '') + Model.url+ (this.props.parentType||'')} model={Model} actions={this.props.actions} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}/>
    );
  }
}
